<template>
    <div class="rows-explain-wrapper">
        <div class="rows-explain-block"></div>
        <div class="rows-explain-title">{{ title }}</div>
    </div>
</template>

<script>

export default {
    name: 'RowsExplain',
    props: {
        title: {
            type: String,
            isRequired: true,
            default: ''
        }
    }
};
</script>

<style lang="scss">
.rows-explain-wrapper {
    display: flex;
    align-items: center;
    background: $bg-white;

    .rows-explain-block {
        margin-right: 8px;
        width: 6px;
        height: 20px;
        background: $green-primary;
    }

    .rows-explain-title {
        height: 24px;
        font-size: 18px;
        font-weight: 500;
        color: $text-secondary;
        line-height: 24px;
    }
}
</style>
